export default (payload) => {
    const { currency } = payload

    return useFetchWithTanstackQuery({
        queryKey: ['paymentMethods'],
        queryFn: () => $fetch(`/api/payment/general/availablePaymentMethods/${currency}`),
    })
}
